import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React components
import TransparentBlogCard from "examples/Cards/BlogCards/TransparentBlogCard";
import BackgroundBlogCard from "examples/Cards/BlogCards/BackgroundBlogCard";

// Images
import post4 from "assets/images/examples/blog2.jpg";

function Places() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid container item xs={12} lg={6}>
          <MKTypography variant="h3" mb={6}>
            Check my latest blogposts
          </MKTypography>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image="https://t3.ftcdn.net/jpg/07/46/93/48/240_F_746934858_KdNWDoon5E2f70OrSwV7LnpqtnodRRw9.jpg"
              title="Breakthrough in Quantum Computing"
              description="Our team has made significant progress in quantum algorithm development, potentially revolutionizing cryptography and optimization problems..."
              action={{
                type: "internal",
                route: "/pages/blogs/author",
                color: "info",
                label: "read more",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image="https://t4.ftcdn.net/jpg/07/02/78/71/240_F_702787162_VPuu9QO9KtbpcA6lRMSfE7YB8Li0N6r2.jpg"
               title="AI in Climate Change Modeling"
                description="New machine learning techniques are enhancing our ability to predict and mitigate the effects of climate change..."
                action={{
                  type: "internal",
                  route: "/pages/blogs/author",
                  color: "info",
                  label: "read more",
                }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image="https://t3.ftcdn.net/jpg/08/64/57/88/240_F_864578846_J1uoplTATkvu6o8Jw7maQjoCRieuBkbi.jpg"
             title="Advancements in Biomedical Imaging"
              description="Our latest research in biomedical imaging techniques promises earlier detection of various diseases..."
              action={{
                type: "internal",
                route: "/pages/blogs/author",
                color: "info",
                label: "read more",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <BackgroundBlogCard
              image={post4}
              title="Sustainable Energy Solutions"
              description="Exploring innovative approaches to renewable energy storage and distribution."
              action={{
                type: "internal",
                route: "/pages/blogs/author",
                label: "read more",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Places;
